import React, { ReactElement } from "react";
import * as palette from "@govlaunch/palette";
import getHostname from "~/lib/utils/getHostname";
import { Anchor } from "@govlaunch/web";
import { FormattedMessage } from "react-intl";
import Compass from "~/components/icons/CompassIcon";

interface IWebsiteProps {
  url: string;
}

export default function Website({ url }: IWebsiteProps): ReactElement {
  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Compass width={38} height={38} />

      <div
        css={{
          marginLeft: 10,
        }}
      >
        <span
          css={{
            fontWeight: 600,
            fontSize: 14,
            display: "flex",
          }}
        >
          <FormattedMessage defaultMessage="Website" id="JkLHGw" />
        </span>

        <Anchor
          href={url}
          external="outside-govlaunch"
          css={{
            color: palette.sealBlue,
            userSelect: "none",
            fontSize: 14,

            "&:focus, &:visited": {
              color: palette.darkGray,
            },

            "&:hover": {
              color: palette.darkGray,
              borderBottom: `solid 1px ${palette.sealBlue}`,
            },
          }}
        >
          {getHostname(url)}
        </Anchor>
      </div>
    </div>
  );
}
